import { Skeleton } from "@/components/ui/skeleton";

/**
 * Skeleton-based fallback for top-level Suspense boundaries.
 * Looks more polished than a centered spinner and signals layout structure.
 */
const SuspenseFallback = () => (
  <div className="min-h-screen bg-background">
    {/* Navbar placeholder */}
    <div className="h-16 border-b border-border/40 px-4 flex items-center gap-3">
      <Skeleton className="h-8 w-8 rounded-lg" />
      <Skeleton className="h-5 w-32 rounded-md" />
      <div className="flex-1" />
      <Skeleton className="h-8 w-8 rounded-full" />
    </div>

    {/* Hero / content placeholder */}
    <div className="max-w-6xl mx-auto px-4 py-8 space-y-6">
      <Skeleton className="h-10 w-2/3 max-w-md rounded-xl" />
      <Skeleton className="h-5 w-1/2 max-w-sm rounded-md" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 pt-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="space-y-3">
            <Skeleton className="h-40 w-full rounded-2xl" />
            <Skeleton className="h-4 w-3/4 rounded-md" />
            <Skeleton className="h-4 w-1/2 rounded-md" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default SuspenseFallback;
